
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicabs() {



    const cardData =
    {
        keyword: 'Pune to Shirdi Cab',
        heading: 'Platinum24 Cabs: Pune to Shirdi Cab',
        headingDescription: 'Platinum24 Cabs provides comfortable Pune to Shirdi Cab services for devotees and travelers seeking a safe and smooth journey to Sai Baba’s holy shrine. Our fleet includes hatchbacks, sedans, SUVs, and luxury cars, ensuring the right choice for solo travelers, families, or groups. With professional drivers familiar with the Pune–Shirdi route, we guarantee punctual pickups, convenient breaks, and a stress-free travel experience. Whether it’s a one-way drop, round-trip, or same-day darshan plan, Platinum24 Cabs delivers affordable fares, transparent pricing, and reliable service for your spiritual journey to Shirdi.',

        top: 'Top Places to Visit in Shirdi with Platinum24 Cabs',

      "topPlaces": [
  {
    "title": "Sai Baba Samadhi Mandir",
    "description": "Sai Baba Samadhi Mandir is Shirdi’s spiritual heart, housing the sacred tomb of Shri Sai Baba. Built in white marble with intricate carvings, it attracts millions of devotees every year. The temple is open almost 20 hours a day, with queues of pilgrims waiting for darshan. Aarti rituals—Kakad, Madhyan, Dhoop, and Shej—create an unforgettable spiritual atmosphere. The sanctity and peace here touch every visitor. Samadhi Mandir is Shirdi’s most revered shrine of faith."
  },
  {
    "title": "Dwarkamai",
    "description": "Dwarkamai is the sacred mosque where Sai Baba lived for over 60 years. It houses the sacred dhuni (eternal flame) lit by Baba, which continues to burn even today. Pilgrims believe the ash (udi) from the dhuni has healing powers. The walls of Dwarkamai still reflect Sai Baba’s simple lifestyle and miracles. Devotees spend hours here in prayer and reflection. Dwarkamai is Shirdi’s divine abode of blessings and grace."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is a small but historic building where Sai Baba used to rest every alternate night. Today, it is a place of worship and reverence, adorned with Baba’s portrait, palanquin, and silver throne. Every Thursday, a grand palkhi procession is carried out from Dwarkamai to Chavadi with devotional chants. The tradition continues to attract thousands of devotees. It is deeply connected to Baba’s legacy. Chavadi is Shirdi’s sacred site of rituals and devotion."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning 'place of the Guru,' is where Sai Baba was first spotted meditating under a neem tree as a young ascetic. A shrine now stands here with a marble idol of Baba, along with a portrait and a sacred Shiva lingam. Pilgrims believe the neem leaves here have medicinal properties. The site exudes calmness and spiritual energy. Gurusthan is Shirdi’s symbolic place of beginnings and enlightenment."
  },
  {
    "title": "Sai Heritage Village",
    "description": "Sai Heritage Village is a theme park and pilgrimage attraction that recreates important events from Sai Baba’s life. Life-size statues, scenes, and exhibits narrate Baba’s teachings and miracles. The park also has a play area and greenery, making it a family-friendly destination. It provides a blend of devotion and recreation. Tourists and children find it educational and engaging. Sai Heritage Village is Shirdi’s living tribute to Sai Baba."
  },
  {
    "title": "Khandoba Mandir",
    "description": "Khandoba Mandir is the temple where Sai Baba was welcomed to Shirdi for the first time. The temple is dedicated to Lord Khandoba, a form of Lord Shiva. It has a small idol of Lord Khandoba along with images of Banai and Mhalsai. The priest Mhalsapati greeted Baba here as ‘Aao Sai,’ which gave him the name 'Sai Baba.' This temple is historically and spiritually significant. Khandoba Mandir is Shirdi’s sacred entry point of devotion."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a beautiful garden developed by Sai Baba himself. It is said he used to water plants here every morning and spend time in meditation. The garden has a Nanda Deep (eternal lamp) lit by Baba, which still burns today. It is a serene place where devotees find peace amidst greenery. Walkways and seating areas make it ideal for reflection. Lendi Baug is Shirdi’s calm sanctuary of nature and devotion."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park is a popular family attraction near the temple town of Shirdi. Spread across 10 acres, it features water slides, wave pools, rain dance, and kids’ play zones. It offers a refreshing break for families and children after a spiritual visit. The park also has restaurants and food courts. It adds fun and leisure to Shirdi’s otherwise devotional aura. Wet N Joy is Shirdi’s entertainment retreat for families."
  },
  {
    "title": "Upasani Maharaj Ashram",
    "description": "Located 5 km from Shirdi, the Upasani Maharaj Ashram is dedicated to one of Sai Baba’s foremost disciples, Upasani Maharaj. The ashram houses his samadhi and is a peaceful retreat for spiritual seekers. It conducts prayers, discourses, and meditation sessions. The place is surrounded by a calm village environment. It is ideal for devotees who wish to explore Sai Baba’s extended spiritual family. The ashram is Shirdi’s serene center of devotion and learning."
  },
  {
    "title": "Shani Shingnapur",
    "description": "Shani Shingnapur, located 70 km from Shirdi, is a unique village temple dedicated to Lord Shani (Saturn). The temple is famous for its open-air idol, with no roof or walls, symbolizing trust and protection. The village is also known for its tradition of houses without doors or locks, as people believe Shani Dev protects them. Pilgrims visiting Shirdi often include this shrine in their journey. Shani Shingnapur is Shirdi’s nearby spiritual extension of faith."
  }
],



      "services": [
    {
      "name": "Pune to Shirdi Cab",
      "description": "Reliable and comfortable cab service from Pune to Shirdi, ensuring timely pickups and drop-offs. Perfect for pilgrims and tourists visiting the famous Sai Baba temple with hassle-free travel options."
    },
    {
      "name": "Pune to Shirdi Taxi",
      "description": "Professional taxi services from Pune to Shirdi offering well-maintained vehicles and experienced drivers focused on safety and customer satisfaction for a smooth journey."
    },
    {
      "name": "Pune to Shirdi Cab Package",
      "description": "All-inclusive cab packages from Pune to Shirdi that cover transportation, tolls, driver allowances, and optional sightseeing tours, designed to provide a comprehensive and convenient travel experience."
    },
    {
      "name": "Pune to Shirdi Cab Charges",
      "description": "Transparent and competitive cab charges for travel between Pune and Shirdi, with no hidden fees. Various vehicle options available to suit different budgets and preferences."
    },
    {
      "name": "Pune to Shirdi Cab fare",
      "description": "Affordable and upfront cab fare options from Pune to Shirdi, ensuring value-for-money travel with comfortable vehicles and professional service."
    },
    {
      "name": "Pune to Shirdi cab one way",
      "description": "Flexible one-way cab services from Pune to Shirdi, ideal for pilgrims and travelers who need reliable point-to-point transportation without round-trip commitments."
    },
    {
      "name": "Pune to Shirdi taxi fare",
      "description": "Competitive taxi fare options for the Pune to Shirdi route, tailored to meet the needs of solo travelers, families, and groups with emphasis on safety and punctuality."
    },
    {
      "name": "Shirdi to Pune Cab",
      "description": "Dependable cab service from Shirdi back to Pune, offering timely pickups and comfortable rides, perfect for returning pilgrims and tourists."
    },
    {
      "name": "Pune to Shirdi Cab Service",
      "description": "Dedicated cab service from Pune to Shirdi with a focus on customer satisfaction, timely service, and comfortable travel experiences for all passengers."
    },
    {
      "name": "Pune to Shirdi cab booking service",
      "description": "Convenient online cab booking service for Pune to Shirdi trips, featuring instant confirmation, multiple payment options, and 24/7 customer support."
    },
    {
      "name": "Pune to Shirdi taxi drop",
      "description": "Reliable taxi drop service from Pune to Shirdi ensuring on-time arrivals and safe journeys, perfect for hassle-free pilgrimage travel."
    },
    {
      "name": "Pune airport to Shirdi cab",
      "description": "Specialized airport cab service connecting Pune Airport to Shirdi, designed for travelers arriving by air and seeking comfortable transportation to the holy town."
    },
    {
      "name": "Pune to Shirdi car rental",
      "description": "Flexible car rental options from Pune to Shirdi, including self-drive and chauffeur-driven vehicles to suit your travel style and convenience."
    },
    {
      "name": "Pune to Shirdi cab booking",
      "description": "Simple and quick online cab booking from Pune to Shirdi with instant confirmation and reliable service, ensuring a smooth start to your pilgrimage or tour."
    },
    {
      "name": "Pune to Shirdi cab price",
      "description": "Competitive pricing on cab services from Pune to Shirdi, with transparent quotes that help you plan your budget effectively without surprises."
    },
    {
      "name": "Pune airport to Shirdi cab price",
      "description": "Affordable and transparent cab prices for rides from Pune Airport to Shirdi, tailored to suit airport travelers seeking comfortable and timely transfers."
    },
    {
      "name": "Cab for Shirdi from Pune",
      "description": "Dependable cab options for travel from Pune to Shirdi, offering a range of vehicles and packages to meet diverse needs and preferences."
    },
    {
      "name": "Pune airport to Shirdi taxi fare",
      "description": "Competitive taxi fare options for transfers from Pune Airport to Shirdi, ensuring a hassle-free and cost-effective journey for air travelers."
    },
    {
      "name": "Pune airport to Shirdi taxi drop",
      "description": "Efficient taxi drop service from Pune Airport to Shirdi that guarantees punctuality and comfort, designed specifically for seamless airport transfers."
    },
    {
      "name": "Pune to Shirdi cab cost",
      "description": "Detailed and transparent cab cost structure for Pune to Shirdi trips, with options ranging from budget to premium vehicles, ensuring value for every traveler."
    }
  ],
  "tableData": [
    ["Pune to Shirdi Cab", "Pune to Shirdi Taxi"],
    ["Pune to Shirdi Cab Package", "Pune to Shirdi Cab Charges"],
    ["Pune to Shirdi Cab fare", "Pune to Shirdi cab one way"],
    ["Pune to Shirdi taxi fare", "Shirdi to Pune Cab"],
    ["Pune to Shirdi Cab Service", "Pune to Shirdi cab booking service"],
    ["Pune to Shirdi taxi drop", "Pune airport to Shirdi cab"],
    ["Pune to Shirdi car rental", "Pune to Shirdi cab booking"],
    ["Pune to Shirdi cab price", "Pune airport to Shirdi cab price"],
    ["Cab for Shirdi from Pune", "Pune airport to Shirdi taxi fare"],
    ["Pune airport to Shirdi taxi drop", "Pune to Shirdi cab cost"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Shirdi Cab Services",
        "WhyChoosedescription": "Platinum24 Cabs offers cost-effective and comfortable cab rides from Pune to Shirdi for a hassle-free pilgrimage or trip."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Long Journeys",
        "WhyChoosedescription": "Travel in comfort with our well-maintained cabs, designed to make your Pune to Shirdi journey smooth and relaxing."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We ensure all vehicles are regularly cleaned and sanitized before every trip to maintain high hygiene standards."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route Expertise",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Shirdi route, guaranteeing a safe and timely trip."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customized packages to fit your travel needs."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy clear, all-inclusive pricing covering fuel, tolls, and driver allowances for complete peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Pilgrimages, Family Trips, and Group Travel",
        "WhyChoosedescription": "Our Pune to Shirdi cabs cater to religious journeys, family visits, and group tours alike."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary changes, and special requests."
    }
]















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Shirdi?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Shirdi.',
    },
    {
        question: 'How can I book a Pune to Shirdi cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Shirdi cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Shirdi trips?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Shirdi?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Shirdi route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Shirdi?',
        answer: 'Absolutely! We provide round-trip cab options with flexible scheduling according to your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Shirdi cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Shirdi rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Shirdi route.',
    },
    {
        question: 'Are safety measures in place for Pune to Shirdi cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols for your protection.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Shirdi travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Shirdi?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Shirdi routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prakash Kulkarni',
        feedback: 'The Pune to Shirdi cab service by Platinum24 Cabs was excellent. The driver was punctual and the ride was comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Mehta',
        feedback: 'I had a great experience traveling to Shirdi with Platinum24 Cabs. The booking was easy and the service top-notch.',
        rating: 5,
    },
];





























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const puneToShirdiCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-shirdi-cab.jpg",
  "description": "Book reliable Pune to Shirdi cab service with Platinum24 Cabs. Affordable one-way and round trip taxi options with verified drivers and 24/7 customer support.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "20100",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-shirdi-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Shirdi Cab | Affordable Taxi Service | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book reliable Pune to Shirdi cab service with Platinum24 Cabs. Affordable one-way and round trip taxi options with verified drivers and 24/7 customer support."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Cab, Pune to Shirdi Taxi, Pune to Shirdi Cab Package, Pune to Shirdi Cab Charges, Pune to Shirdi Cab fare, Pune to Shirdi cab one way, Pune to Shirdi taxi fare, Shirdi to Pune Cab, Pune to Shirdi Cab Service, Pune to Shirdi cab booking service, Pune to Shirdi taxi drop, Pune airport to Shirdi cab, Pune to Shirdi car rental, Pune to Shirdi cab booking, Pune to Shirdi cab price, Pune airport to Shirdi cab price, Cab for Shirdi from Pune, Pune airport to Shirdi taxi fare, Pune airport to Shirdi taxi drop, Pune to Shirdi cab cost"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToShirdiCabSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/9.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirdicabs;